/**
 * The usage log: every indexed, approved, published, hidden or deleted event this brand took part in, as
 * the using brand or as owner of a shared target. Clips and sounds count as used when a post is approved;
 * composed and rendered rows are from before that (2026-10-04).
 */
import { useQuery } from '@tanstack/react-query';
import { TopBar } from '@/components/shell';
import { trpc } from '@/lib/trpc';

const KIND_LABEL: Record<string, string> = {
  indexed: 'Indexed',
  composed: 'Composed',
  rendered: 'Rendered',
  approved: 'Approved',
  published: 'Published',
  linked: 'Linked',
  hidden: 'Hidden',
  deleted: 'Deleted',
};

export function UsageLogPage() {
  const usage = useQuery(trpc.usage.list.queryOptions({}));
  return (
    <>
      <TopBar title="Usage log" />
      <section className="content col">
        <div className="card lib-table">
          <table className="tbl">
            <thead><tr><th>When</th><th>Event</th><th>Target</th><th>By</th><th></th></tr></thead>
            <tbody>
              {usage.data?.map((u) => (
                <tr key={u.id}>
                  <td className="sub mono">{new Date(u.at).toLocaleString()}</td>
                  <td>{KIND_LABEL[u.kind] ?? u.kind}</td>
                  <td><b>{u.targetName}</b></td>
                  <td className="sub">{u.by ?? ''}</td>
                  <td>{u.asOwner ? <span className="chip acc">used by another brand</span> : u.crossBrand ? <span className="chip">shared item</span> : null}</td>
                </tr>
              ))}
              {usage.data?.length === 0 && <tr><td colSpan={5} className="sub creator-empty">Nothing yet. Indexing, composing and publishing all log here.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
